import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoAmostraParams from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import { useForm } from "react-final-form";
import TC from "..";

export default function TCEditFields({ visita, TipoClass }) {
    const [apontamento] = useFieldValue();

    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = TC.calcConformidade(apontamento, null);
            form.change("coletas", apontamento.coletas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} showTrator={false} showImplemento={false} />

            <ApontamentoAmostraParams />

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="coleta" label="Coleta" />
            </ApontamentoColetas>

            <ApontamentoResultado showConformidadeField={false} />

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
